var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isLoading)?_vm._t("loader"):_vm._e(),_vm._v(" "),(_vm.catalogIsActive)?_c('div',[_c('catalog-product-list',{attrs:{"data-source":_vm.dataSource}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }